import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  Activities,
  RootState,
  transactionRequest,
  transactionsDownloadRequest,
  eppRequest,
  useProductName,
  contactInfoRequest,
  environment,
} from '@rb-serve-app/core';

import { CheckIcon } from '../../assets/svg/CheckIcon';
import Modal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import TransactionDetails from '../../components/TransactionDetails';
import moment from 'moment';
import Button from '../../components/Button';
import { EventType, useAnalytics } from '../../ui/Analytics';

import Breadcrumbs from '../../components/BreadCrumbs';
import RadioButton from '../../components/RadioButton';
import { DownloadTransactionIcon } from '../../assets/svg/DownloadTransactionIcon';
import FeatureFlagMessage from '../../components/FeatureFlagMessage';
import { BalanceIcon } from '../../assets/svg/StatusIcon';
import { ArrowDownIcon } from '../../assets/svg/ArrowDownIcon';
import TransactionTable from './TransactionTable';
import { useRecaptchaToken } from '@rb-serve-app/core';
import SuccessModel from '../../components/SuccessModel';
import { logBrazeCustomEvent } from '../../config/braze';

interface Transaction {
  id: string;
  date: string;
  amount: {
    value: string;
  };
  merchant: {
    category: string;
    categoryDescription?: string;
    name?: string;
  };
  activityStatus: string;
}

interface AvailableCards {
  nameToUse: string;
  customerType: string;
  nameOnCard: string;
  customerId: string;
  cardNumber: string;
  productExternalCode: string;
  productName: string;
}
const lang = localStorage.getItem('language') || 'en-US';
const Transactions = () => {
  const { trackEvent } = useAnalytics();
  const dispatch = useDispatch();
  const lang = localStorage.getItem('language') || 'en-US';

  const setupLocale = () => {
    try {
      const localeToUse = lang?.includes('fr') ? 'fr' : 'en';
      moment.locale(localeToUse);
      return localeToUse;
    } catch (error) {
      console.warn('Error setting moment locale:', error);
      moment.locale('en');
      return 'en';
    }
  };

  setupLocale();
  const [totalAmount, setTotalAmount] = useState<{ [key: string]: number }>({});
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedCycleDate, setSelectedCycleDate] = useState('');
  const [CardHolders, setCardHolders] = useState<AvailableCards[]>([]);
  const [selectedCard, setSelectedCard] = useState<AvailableCards>(
    {} as AvailableCards
  );
  const [selectedCategory, setSelectedCategory] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState<string>('CSV');
  const [transactionsError, setTransactionsError] = useState(false);

  // State to track applied filters (only updated when Apply button is clicked)
  const [appliedMonth, setAppliedMonth] = useState('');
  const [appliedCategory, setAppliedCategory] = useState('');

  // State to track category changes to detect when user switches back to all categories
  const [previousCategory, setPreviousCategory] = useState('');
  const [
    shouldAllowApplyForAllCategories,
    setShouldAllowApplyForAllCategories,
  ] = useState(false);
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [downloadError, setdownLoadError] = useState(false);

  const { transactions, isFirstLoad, totalCount } = useSelector(
    (state: any) => state.transactions
  );
  const { accountId, customerId, accountDetails, availableCards } = useSelector(
    (state: RootState) => state.user
  );
  const { error } = useSelector(
    (state: RootState) => state.downloadTransactions
  );
  console.log('glo', error);
  const handelErrorClose = () => {
    setdownLoadError(false);
    setTitle('');
    setSubTitle('');
  };

  useEffect(() => {
    if (error && typeof error === 'object' && 'status' in error) {
      const err = error as {
        status?: string | number;
        errorCode?: string | undefined;
      };
      if (err.status === '400' || err.status === '401') {
        const errorcode =
          err.status == '400'
            ? 'ERR_401_RECAPTCHA_VAL_ERROR'
            : 'ERR_401_RECAPTCHA_LOW_SCORE';
        setdownLoadError(true);
        setTitle(entries?.rb_error?.recaptchaErrors?.[errorcode]?.title);
        setSubTitle(
          entries?.rb_error?.recaptchaErrors?.[errorcode]?.description
        );
      }
    } else {
      if (error) {
        setdownLoadError(true);
        setTitle(entries?.rb_error?.genericApiFailure?.header);
        setSubTitle(entries?.rb_error?.genericApiFailure?.text);
      }
    }
  }, [error]);

  const current_login_username = `${accountDetails?.customer?.firstName}${' '}${accountDetails?.customer?.lastName}`;

  const { eppDetails } = useSelector((state: RootState) => state.epp);
  const { contactDetails } = useSelector((state: any) => state.contactInfo);
  const filterButtonRef = useRef<HTMLDivElement>(null);

  const [filteredActivities, setFilteredActivities] = useState<Activities[]>(
    []
  );
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const ButtonRef = useRef<HTMLButtonElement | null>(null);
  const downloadTransactionsModalRef = useRef<HTMLDivElement>(null);
  const selectCardRef = useRef<HTMLDivElement>(null);
  const [selectCardDropdownIsOpen, setSelectCardDropdownIsOpen] =
    useState(false);
  const [activeDownloadTransactions, setActiveDownloadTransactions] =
    useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const { cardStructure, productName } = useProductName();
  const [showFeatureFlagMessage, setShowFeatureFlagMessage] = useState(false);
  const [limit, setLimit] = useState(0);
  const [offset, setOffset] = useState(1);
  const [filterApplied, setFilterApplied] = useState(false);
  const [payloads, setPayload] = useState<{
    accountId?: string;
    customerId?: string;
    offset?: number;
    limit?: number;
    customerTypeId?: string;
    fromDate?: string;
    toDate?: string;
    cycleStartDate?: any;
    merchantCategory?: any;
  }>({});

  useEffect(() => {
    calculateTotalAmount(transactions);
    setFilteredActivities(transactions);
    if (transactions === null || transactions?.length === 0) {
      setTransactionsError(true);
    } else {
      setTransactionsError(false);
    }
  }, [transactions]);

  useEffect(() => {
    if (transactions) {
      filterActivities();
    }
  }, [transactions, searchTerm]);

  useEffect(() => {
    if (accountId && customerId) {
      if (!contactDetails?.availableCards) {
        dispatch(
          contactInfoRequest({
            accountId: accountId,
            customerId: customerId,
            primaryCustomerId: customerId,
          })
        );
      }
    }
    trackEvent(
      EventType.PAGE_VIEW,
      ['transactions history', 'enroll equal payment plans'],
      window.location.href
    );
    logBrazeCustomEvent('viewed_transactions');
  }, []);

  useEffect(() => {
    if (accountId && customerId) {
      dispatch(eppRequest({ accountId, customerId }));
      //dispatch(useraccountDetailsRequest({ accountId, customerId }));
    }
  }, [dispatch, accountId, customerId]);

  useEffect(() => {
    if (accountId && customerId) {
      // By default, don't include customerTypeId when loading initially (shows all cardholders)
      setPayload({ accountId, customerId, offset });
      dispatch(transactionRequest({ accountId, customerId, offset }));
    }
  }, [accountId, customerId]);
  useEffect(() => {
    if (accountId && customerId && offset > 1) {
      const payload = { ...payloads, accountId, customerId, offset };
      console.log('payload offset2', payload);
      dispatch(transactionRequest(payload as Required<typeof payload>));
    }
  }, [offset]);

  useEffect(() => {
    if (
      contactDetails?.availableCards &&
      contactDetails?.availableCards?.length
    ) {
      const formattedCards = contactDetails?.availableCards.map(
        (card: AvailableCards) => {
          return {
            ...card,
            cardNumber: card.cardNumber.substring(card.cardNumber.length - 4),
          };
        }
      );

      const primaryCard = formattedCards.find(
        (card: AvailableCards) =>
          card.customerType.toLocaleLowerCase() === 'primary'
      );
      if (formattedCards.length == 1) {
        setSelectedCard(formattedCards[0]);
        setCardHolders([formattedCards]);
      } else {
        if (primaryCard) {
          // setSelectedCard(primaryCard);
          // Create "All cardholders" option using primary card's details
          const allCardholdersOption = {
            ...primaryCard,
            nameOnCard: rb_common.commonString.allCardholders,
          };
          setSelectedCard(allCardholdersOption);

          setCardHolders([allCardholdersOption, ...formattedCards]);
        }
      }
    }
  }, [contactDetails]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterButtonRef.current &&
        !filterButtonRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
      if (
        downloadTransactionsModalRef.current &&
        !downloadTransactionsModalRef.current.contains(event.target as Node)
      ) {
        setActiveDownloadTransactions(false);
      }
      if (
        selectCardRef.current &&
        !selectCardRef.current.contains(event.target as Node)
      ) {
        setSelectCardDropdownIsOpen(false);
      }
    };
    document.body.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.body.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const trackClickEvent = (name: string) => {
    trackEvent(
      EventType.CLICK_EVENT,
      ['transactions history', 'enroll equal payment plans'],
      window.location.href,
      `${name}`
    );
  };

  // Helper function to determine if download button should be visible
  const shouldShowDownloadButton = () => {
    // Always show download button regardless of any filtering criteria
    return true;
  };

  // Helper function to determine if Apply button should be enabled
  const shouldEnableApplyButton = () => {
    // Special case: Enable when user switches back to all categories even if month is -Select-
    if (
      shouldAllowApplyForAllCategories &&
      selectedCategory === '' &&
      selectedMonth === ''
    ) {
      return true;
    }

    // Enable Apply button only if at least one filter is selected (not the default placeholder)
    return selectedMonth !== '' || selectedCategory !== '';
  };

  const clearFilter = () => {
    setSearchTerm('');
    // Reset filterApplied when filters are cleared
    setFilterApplied(false);

    // Clear applied filter values
    setAppliedMonth('');
    setAppliedCategory('');

    // Reset the special flag
    setShouldAllowApplyForAllCategories(false);
    if (accountId && customerId) {
      // Include customerTypeId for primary and authorized users, but not for "All cardholders"
      const isAllCardholders =
        selectedCard?.nameOnCard === rb_common.commonString.allCardholders;
      const customerTypeId = !isAllCardholders
        ? selectedCard?.customerId
        : undefined;

      setPayload({
        accountId,
        customerId, // Always use primary customer ID
        limit: 0,
        customerTypeId: customerTypeId, // Include for primary and authorized users
        offset: 1,
      });
      dispatch(
        transactionRequest({
          accountId,
          customerId, // Always use primary customer ID
          limit: 0,
          customerTypeId: customerTypeId, // Include for primary and authorized users
          offset: 1,
        })
      );
    }
  };

  const filterActivities = useCallback(() => {
    if (transactions) {
      const normSearch = searchTerm.trim().toLowerCase();
      const filtered = transactions.filter((transaction: any) => {
        // Check if the search term is empty or if the activity matches the search term
        //  let cat = transaction.merchant.category.toLowerCase().split(' ').join("_");
        //  console.log("cat",cat)
        const categoryKey = transaction.merchant.category
          ?.toLowerCase()
          .replace(/\s+/g, '_');

        const localizedCategory =
          rb_recent_transactions?.filterCategoryList?.[categoryKey] ?? '';

        const matchesSearch =
          normSearch === '' ||
          transaction.merchant.name?.toLowerCase().includes(normSearch) ||
          localizedCategory.toLowerCase().includes(normSearch);

        const matchesCategory =
          !selectedCategory || categoryKey === selectedCategory;

        return matchesSearch && matchesCategory;
      });
      setFilteredActivities(filtered);
      calculateTotalAmount(filtered);
    }
  }, [transactions, searchTerm, selectedCategory]);

  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );

  const { entries, assets } = contentfulData || {};

  const { rb_transaction_history, rb_recent_transactions, rb_epp, rb_common } =
    entries || {};
  const getRecaptchaToken = useRecaptchaToken();

  const navigate = useNavigate();

  const updateViewState = () => {
    navigate('/');
  };

  const openModal = (transaction: any) => {
    // Always open the transaction details modal for all transactions
    setSelectedTransaction(transaction);
    setModalIsOpen(true);
    trackEvent(
      EventType.PAGE_VIEW,
      ['modal transaction details', 'enroll equal payment plans'],
      window.location.href
    );

    // Track specific event for EPP eligible transactions
    if (transaction.eligibleforEPP) {
      trackClickEvent('transactions history|epp eligible transaction');
    } else {
      trackClickEvent('transactions history|view');
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
    trackEvent(
      EventType.CLICK_EVENT,
      'modal transaction details',
      window.location.href,
      'modal transaction details|close'
    );
  };
  console.log('glo', error);
  const handleDownloadTransactions = async () => {
    console.log('calling download');
    if (!selectedCycleDate) return;
    const token = await getRecaptchaToken('transaction_download');
    if (accountId && customerId) {
      const payload: any = {
        accountId,
        customerId,
        selectedFileType: selectedFileType,
        recaptchaToken: token,
      };

      // Handle current transactions differently
      if (selectedCycleDate === 'current_transactions') {
        // For current transactions, use fromDate and toDate instead of cycleDate
        //  payload.fromDate = fromDate;
        // payload.toDate = toDate;
      } else {
        // For specific periods, use cycleDate
        payload.cycleDate = selectedCycleDate;
      }

      dispatch(transactionsDownloadRequest(payload));
      trackClickEvent('transactions history|download transactions');
    }
  };

  const handleClearDownload = () => {
    setActiveDownloadTransactions(false);
    setSelectedCycleDate('');
    setSelectedFileType('CSV');
  };

  const calculateTotalAmount = (
    filteredTransactions: Transaction[] = transactions
  ) => {
    const totals: { [key: string]: number } = {};
    const transactionsToProcess = Array.isArray(filteredTransactions)
      ? filteredTransactions
      : [];
    transactionsToProcess.forEach((transaction: Transaction) => {
      const status = transaction.activityStatus;
      const amount = parseFloat(transaction.amount.value);
      if (!isNaN(amount)) {
        if (!totals[status]) {
          totals[status] = 0;
        }
        totals[status] += amount;
      }
    });
    setTotalAmount(totals);
  };

  const handleMonthChange = (month: any) => {
    if (month === 'current_month') {
      setSelectedMonth('current_month');
      month = current_transaction_filter_date;
    } else {
      setSelectedMonth(month);
    }
    trackClickEvent('transactions history|select month');
    // setIsOpen(false);
  };

  const handleCycleDateChange = (cycleDate: string) => {
    setSelectedCycleDate(cycleDate);
    trackClickEvent('transactions history|select cycleDate');
  };

  const handleCardChange = (customerIdSelection: string) => {
    const customerIdSplit = customerIdSelection.split('_');

    // Include customerTypeId for primary and authorized users, but not for "All cardholders"
    const isAllCardholders =
      customerIdSplit[0] === rb_common.commonString.allCardholders;
    const customerTypeId = !isAllCardholders ? customerIdSplit[1] : undefined;

    const selectedCardOption = CardHolders.find(
      (card) =>
        card?.customerId === customerIdSplit[1] &&
        card?.nameOnCard === customerIdSplit[0]
    );

    if (selectedCardOption) {
      setSelectedCard(selectedCardOption);
    }
    const month =
      selectedMonth == 'current_month'
        ? accountDetails?.cycleDates?.[0]
        : selectedMonth;
    const fromDate = moment(accountDetails?.cycleDates?.[0]).format(
      'YYYY-MM-DD'
    );
    const toDate = moment().format('YYYY-MM-DD');

    if (selectedMonth == 'current_month') {
      // For current transactions, use fromDate and toDate with limit and offset
      const payload = {
        accountId,
        customerId: customerId, // Always use primary customer ID in URL
        limit: 0,
        offset: 1,
        fromDate,
        toDate,
        customerTypeId: customerTypeId, // Include for primary and authorized users
        merchantCategory: selectedCategory,
      };
      setPayload(payload);
      dispatch(transactionRequest(payload));
    } else {
      const payload = {
        accountId,
        customerId: customerId, // Always use primary customer ID in URL
        limit,
        cycleStartDate: month,
        customerTypeId: customerTypeId, // Include for primary and authorized users
        merchantCategory: selectedCategory,
        offset: 1,
      };
      setPayload(payload);
      dispatch(transactionRequest(payload));
    }

    setSelectCardDropdownIsOpen(false);
    trackClickEvent('transactions history|select card');
  };

  const handleCategoryChange = (category: string) => {
    // Track previous category to detect when user switches back to all categories
    setPreviousCategory(selectedCategory);

    if (category === '' || category === 'all_categories') {
      // If user had a specific category selected and switches back to all categories
      if (selectedCategory !== '') {
        setShouldAllowApplyForAllCategories(true);
      }
      setSelectedCategory('');
    } else {
      // Store the category key instead of formatted display value
      // This ensures consistent comparison across languages
      setSelectedCategory(category);
      // Reset the special flag when selecting a specific category
      setShouldAllowApplyForAllCategories(false);
    }

    trackClickEvent('transactions history|select category');
    // setIsOpen(false);
  };

  const applyMonthCategoryChanges = () => {
    // Set filterApplied to true when Apply is clicked
    setFilterApplied(true);

    // Update applied filter values to track what was actually applied
    setAppliedMonth(selectedMonth);
    setAppliedCategory(selectedCategory);

    // Reset the special flag after applying the filter
    setShouldAllowApplyForAllCategories(false);

    // Handle case where both month is -Select- and category is All Categories
    // This should return to initial screen (default state)
    if (selectedMonth === '' && selectedCategory === '') {
      if (accountId && customerId) {
        // Load initial default transactions without any filters
        const payload = {
          accountId,
          customerId,
          offset: 1,
        };
        setPayload(payload);
        dispatch(transactionRequest(payload));
      }
      setIsOpen(false);
      return;
    }

    if (selectedCategory !== '' && selectedMonth === '') {
      filterActivities();
      setIsOpen(false);
      return;
    }
    // setSearchTerm('');
    // Include customerTypeId for primary and authorized users, but not for "All cardholders"
    const isAllCardholders =
      selectedCard?.nameOnCard === rb_common.commonString.allCardholders;
    const customerTypeId = !isAllCardholders
      ? selectedCard?.customerId
      : undefined;

    const month =
      selectedMonth === 'current_month' && accountDetails?.cycleDates
        ? accountDetails?.cycleDates?.[0]
        : selectedMonth;
    let fromDate: any;
    let toDate: any;
    if (selectedMonth === 'current_month') {
      fromDate = moment(accountDetails?.cycleDates?.[0]).format('YYYY-MM-DD');
      toDate = moment().format('YYYY-MM-DD');
    } else {
      fromDate = moment(month).startOf('month').format('YYYY-MM-DD');
      toDate = moment(month).endOf('month').format('YYYY-MM-DD');
    }
    if (selectedMonth === 'current_month') {
      // For current transactions, use fromDate and toDate with limit and offset
      const payload = {
        accountId,
        customerId, // Always use primary customer ID
        limit: 0,
        offset: 1,
        fromDate,
        toDate,
        customerTypeId: customerTypeId, // Include for primary and authorized users
        merchantCategory: selectedCategory,
      };
      setPayload(payload);
      dispatch(transactionRequest(payload));
    } else {
      console.log('calling apply 2');
      const payload = {
        accountId,
        customerId, // Always use primary customer ID
        limit,
        fromDate,
        toDate,
        customerTypeId: customerTypeId, // Include for primary and authorized users
        merchantCategory: selectedCategory,
        offset: 1,
      };
      setPayload(payload);
      dispatch(transactionRequest(payload));
    }
    trackClickEvent('transactions history|apply');
    setIsOpen(false);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    // trackClickEvent('transactions history|search');
    setTimeout(() => {
      trackEvent(
        EventType.CLICK_EVENT,
        ['transactions history', 'enroll equal payment plans'],
        window.location.href,
        'transactions history|search',
        false,
        {},
        undefined,
        false,
        {},
        false,
        true,
        { type: 'transactions history', keyword: event.target.value }
      );
    }, 1000);
  };

  const getButtonPosition = () => {
    setIsOpen((prev) => !prev);
    if (ButtonRef.current) {
      const rect = ButtonRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top,
        left: rect.left,
      });
    }
  };

  // const groupedActivities = (
  //   Array.isArray(filteredActivities) ? filteredActivities : []
  // ).reduce((groups: any, transaction: any) => {
  //   const status = transaction.activityStatus;
  //   if (!groups[status]) {
  //     groups[status] = [];
  //   }
  //   groups[status].push(transaction);
  //   return groups;
  // }, {});

  // Group activities by status with specific order
  const groupedActivities = (() => {
    const items = Array.isArray(filteredActivities) ? filteredActivities : [];
    const orderedKeys = ['PENDING', 'DECLINED', 'APPROVED'];

    // containers: only create ordered group entries when we encounter items
    const orderedGroups: { [key: string]: any[] } = {};
    // collect other statuses separately
    const otherGroups: { [key: string]: any[] } = {};

    items.forEach((transaction: any) => {
      const rawStatus = transaction?.activityStatus ?? '';
      const status = String(rawStatus).toUpperCase();

      if (orderedKeys.includes(status)) {
        if (!orderedGroups[status]) orderedGroups[status] = [];
        orderedGroups[status].push(transaction);
      } else {
        if (!otherGroups[status]) otherGroups[status] = [];
        otherGroups[status].push(transaction);
      }
    });

    // build final object: ordered keys first (only if they exist), then any other statuses
    const result: { [key: string]: any[] } = {};
    orderedKeys.forEach((k) => {
      if (orderedGroups[k] && orderedGroups[k].length > 0) {
        result[k] = orderedGroups[k];
      }
    });
    Object.keys(otherGroups).forEach((k) => {
      result[k] = otherGroups[k];
    });

    return result;
  })();

  interface MonthObject {
    key: string;
    value: string;
  }

  const current_transaction_filter_date =
    accountDetails &&
    accountDetails?.cycleDates &&
    moment(accountDetails?.cycleDates?.[0]).format('MMM YYYY');

  const getUniqueMonthsWithEarliestDate = useCallback(
    (dates: string[]) => {
      const monthMap = new Map();

      dates.forEach((date) => {
        const monthKey = moment(date).format('YYYY-MM');
        if (!monthMap.has(monthKey)) {
          monthMap.set(monthKey, date);
        } else {
          // If the current date is earlier, update the map with the new earliest date
          if (moment(date).isBefore(moment(monthMap.get(monthKey)))) {
            monthMap.set(monthKey, date);
          }
        }
      });

      // Return the earliest date for each month
      return Array.from(monthMap.values());
    },
    [accountDetails?.cycleDates]
  );

  const transactionCycleDates = useMemo(() => {
    if (
      accountDetails?.cycleDates &&
      Array.isArray(accountDetails?.cycleDates)
    ) {
      return getUniqueMonthsWithEarliestDate(accountDetails?.cycleDates); //  cycleDates.map((date) => moment(date).format('MMM YYYY'));
    }
    return null;
  }, [accountDetails?.cycleDates]);

  const breadcrumbs = [
    {
      name: entries?.rb_navigation?.homeLogoTitle,
      href: '/home',
      icon: '/path/to/home-icon.png',
    },
    { name: `${rb_transaction_history?.titleWeb}`, href: '/transactions' },
  ];

  console.log('CardHolders', totalCount);
  return (
    <>
      {downloadError && (
        <SuccessModel
          isOpen={downloadError}
          title={title}
          subTitle={subTitle}
          successIcon={false}
          closeModal={handelErrorClose}
          errorIcon={false}
        />
      )}
      {showFeatureFlagMessage && (
        <FeatureFlagMessage className="md:left-20 left-0" />
      )}
      {rb_transaction_history && (
        <div className="h-full md:w-full overflow-hidden ">
          <div className="bg-bg-body py-4 md:px-8 px-4">
            <Breadcrumbs items={breadcrumbs} />
            <div className="w-full rounded-[15px] bg-white min-h-[70vh] flex-1 flex-col overflow-y-scroll scrollbar-hide md:p-6 p-2">
              <div
                className="flex flex-row items-center relative"
                ref={downloadTransactionsModalRef}
              >
                <h2
                  aria-label={rb_transaction_history?.titleWeb}
                  className="text-[16px] font-bold flex-1 md:text-3xl"
                >
                  {rb_transaction_history?.titleWeb}
                </h2>
                {shouldShowDownloadButton() && (
                  <div
                    className={`cursor-pointer flex items-center gap-2.5 border border-solid border-[#DA291C] text-[#DA291C] p-2.5 text-base font-semibold ${activeDownloadTransactions ? 'bg-[#DA291C] text-[#FFF]' : ''}`}
                    onClick={() => {
                      // If toggling on, set the selected cycle date based on the current filter
                      if (!activeDownloadTransactions && filterApplied) {
                        // Only auto-fill if filters were applied via the Apply button
                        if (
                          appliedMonth === 'current_month' &&
                          appliedCategory === ''
                        ) {
                          // Auto-select "current_transactions" when current transactions filter is applied
                          setSelectedCycleDate('current_transactions');
                        } else if (selectedMonth && selectedMonth !== '') {
                          if (
                            selectedMonth === 'current_month' &&
                            accountDetails?.cycleDates?.[0]
                          ) {
                            setSelectedCycleDate(accountDetails.cycleDates[0]);
                          } else {
                            setSelectedCycleDate(selectedMonth);
                          }
                        } else if (
                          payloads.cycleStartDate &&
                          payloads.cycleStartDate !== ''
                        ) {
                          // If there's a cycleStartDate in the payload, use that
                          setSelectedCycleDate(payloads.cycleStartDate);
                        }
                      } else if (!activeDownloadTransactions) {
                        // If filter wasn't applied, ensure the dropdown remains empty
                        setSelectedCycleDate('');
                      }
                      setActiveDownloadTransactions((prevState) => !prevState);
                    }}
                  >
                    <p
                      className="hidden md:block"
                      aria-label={rb_transaction_history?.downloadTransactions}
                    >
                      {rb_transaction_history?.downloadTransactions}
                    </p>
                    {activeDownloadTransactions ? (
                      <DownloadTransactionIcon />
                    ) : (
                      <img
                        src={assets.statement_download_web_icon}
                        className="w-6 h-6"
                        alt="StatementDownloadWebIcon"
                      />
                    )}
                  </div>
                )}
                {shouldShowDownloadButton() && activeDownloadTransactions && (
                  <div
                    className="absolute flex flex-1 bg-white border border-gray-300 rounded-lg shadow-lg z-10 max-w-[370px] text-[#1F1F1F] p-5 "
                    role="dialog"
                    style={{
                      top: '50px',
                      right: '0px',
                    }}
                  >
                    <div className="p-4">
                      <div className="mb-4">
                        <div>
                          <h3
                            className="text-base font-semibold pb-3.5"
                            aria-label={
                              rb_transaction_history?.downloadTransactionPopupTitle
                            }
                          >
                            {
                              rb_transaction_history?.downloadTransactionPopupTitle
                            }
                          </h3>
                        </div>
                        <label
                          className="block text-[#1F1F1F] mb-3.5"
                          htmlFor="month-select"
                          aria-label={
                            rb_transaction_history?.transactionsPeriodTitle
                          }
                        >
                          {rb_transaction_history?.transactionsPeriodTitle}
                        </label>
                        <div
                          className={`pl-3 pr-3 pt-2 pb-2 border ${transactionsError ? 'border-[#DA291C]' : 'border-gray-300'} rounded`}
                        >
                          <select
                            value={selectedCycleDate}
                            onChange={(e) =>
                              handleCycleDateChange(e.target.value)
                            }
                            className="w-full border-gray-300 focus:border-gray-500 focus:outline-none"
                            id="month-select"
                          >
                            <option
                              value=""
                              className="text-[#666666]"
                              aria-label={
                                rb_transaction_history?.transactionsSelectOption
                              }
                            >
                              {rb_transaction_history?.transactionsSelectOption}
                            </option>
                            <option
                              key="current_transactions"
                              value="current_transactions"
                            >
                              Current transactions
                            </option>
                            {transactionCycleDates?.map((date) => (
                              <option key={date} value={date}>
                                {moment(date).locale(lang).format('MMM YYYY')}
                              </option>
                            ))}
                          </select>
                        </div>
                        {transactionsError && (
                          <div className="flex items-center gap-1 mt-2">
                            <BalanceIcon
                              fill="#DA291C"
                              width="14"
                              height="14"
                            />
                            <p
                              aria-label={
                                rb_transaction_history?.transactionsFilter
                                  ?.notransactionsavailable
                              }
                              className={`text-[#DA291C] font-500`}
                            >
                              {
                                rb_transaction_history?.transactionsFilter
                                  ?.notransactionsavailable
                              }
                            </p>
                          </div>
                        )}
                      </div>
                      <div>
                        <label
                          htmlFor="category-select"
                          className="block text-[#1F1F1F] mb-3.5"
                          aria-label={
                            rb_transaction_history?.transactionsSelectType
                          }
                        >
                          {rb_transaction_history?.transactionsSelectType}
                        </label>
                        <div className="flex items-center gap-[15px]">
                          <RadioButton
                            selected={selectedFileType === 'CSV'}
                            onPress={() => {
                              setSelectedFileType('CSV');
                            }}
                            label={rb_transaction_history?.filetypeCsv}
                          />
                          <RadioButton
                            selected={selectedFileType === 'OFX'}
                            onPress={() => {
                              setSelectedFileType('OFX');
                            }}
                            label={rb_transaction_history?.filetypeOfx}
                          />
                        </div>
                      </div>

                      <div className="flex flex-1 flex-row justify-between my-5 gap-5">
                        <Button
                          ariaLabel={
                            rb_transaction_history?.downloadTransactionsCancelBtn
                          }
                          variant={'secondary'}
                          className="w-full"
                          onClick={() => {
                            handleClearDownload();
                            trackClickEvent(
                              'transactions history|cancel download'
                            );
                          }}
                        >
                          {
                            rb_transaction_history?.downloadTransactionsCancelBtn
                          }
                        </Button>
                        <Button
                          ariaLabel={
                            rb_transaction_history?.downloadTransactionsDownloadBtn
                          }
                          className={`bg-[#DA291C] text-white pl-4 pr-4 pt-2 pb-2 w-full ${
                            selectedCycleDate
                              ? 'hover:bg-red-700'
                              : 'opacity-50 cursor-not-allowed'
                          }`}
                          onClick={async () => {
                            handleDownloadTransactions();
                            handleClearDownload();
                          }}
                          disabled={selectedCycleDate ? false : true}
                        >
                          {
                            rb_transaction_history?.downloadTransactionsDownloadBtn
                          }
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="md:bg-[#f5f5f5] md:rounded-lg md:shadow flex flex-col ipad-landscape:flex-row max-md:flex-col md:p-5 mt-5">
                {/* selection of card dropdown */}
                {CardHolders.length > 0 && (
                  <div className="flex items-center gap-[20px]">
                    <div className="flex flex-col gap-[11px] w-full relative">
                      <p className="text-[#1F1F1F] text-[15px] font-[500] leading-[18px] tracking-[-0.012px]">
                        {CardHolders.length > 1 && (
                          <>
                            <label
                              htmlFor="cardholder-selector"
                              className="sr-only"
                              id="cardholder-selector-label"
                            >
                              {rb_transaction_history?.showingTitle ||
                                'Select a cardholder'}
                            </label>
                            <span>{rb_transaction_history?.showingTitle}</span>
                          </>
                        )}
                      </p>

                      {CardHolders.length > 1 ? (
                        <div
                          className="relative lg:min-w-[369px]"
                          ref={selectCardRef}
                        >
                          <button
                            id="cardholder-selector"
                            aria-haspopup="listbox"
                            aria-labelledby="cardholder-selector-label cardholder-selector"
                            aria-expanded={selectCardDropdownIsOpen}
                            className="w-full flex justify-between pb-[8px] border-b-[1px] border-[#999999] text-[#1F1F1F] text-[16px] font-[650] leading-[24px] tracking-[-0.051px]"
                            onClick={() =>
                              setSelectCardDropdownIsOpen(
                                (prevState) => !prevState
                              )
                            }
                          >
                            <span>
                              {selectedCard.nameOnCard ===
                              rb_common.commonString.allCardholders
                                ? selectedCard.nameOnCard
                                : `${selectedCard.nameOnCard}... ${selectedCard.cardNumber}`}
                            </span>
                            <ArrowDownIcon />
                          </button>

                          <ul
                            role="listbox"
                            aria-labelledby="cardholder-selector-label"
                            className={`absolute top-[40px] z-40 w-full overflow-auto rounded-[15px] bg-white py-1 text-base focus:outline-none ${selectCardDropdownIsOpen ? 'block' : 'hidden'} shadow-lg`}
                            tabIndex={-1}
                          >
                            {CardHolders.map((card: AvailableCards) => {
                              const isSelected =
                                selectedCard.nameOnCard +
                                  '_' +
                                  selectedCard.customerId ===
                                card.nameOnCard + '_' + card.customerId;

                              return (
                                <li
                                  role="option"
                                  aria-selected={isSelected}
                                  key={card.nameOnCard + '_' + card.customerId}
                                  className="flex justify-between w-full text-[#000] text-[16px] font-[600] leading-[20px] p-[15px] hover:bg-[#f5f5f5] cursor-pointer"
                                  onClick={() =>
                                    handleCardChange(
                                      card.nameOnCard + '_' + card.customerId
                                    )
                                  }
                                >
                                  <span>
                                    {card.nameOnCard ===
                                    rb_common.commonString.allCardholders
                                      ? card.nameOnCard
                                      : `${card.nameOnCard}... ${card.cardNumber}`}
                                  </span>
                                  {isSelected && <CheckIcon />}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      ) : (
                        <p
                          aria-label="Selected cardholder"
                          className="w-full flex justify-between pb-[8px] border-b-[1px] border-[#999999] text-[#1F1F1F] text-[16px] font-[650] leading-[24px] tracking-[-0.051px]"
                        >
                          {selectedCard.nameOnCard ===
                          rb_common.commonString.allCardholders
                            ? selectedCard.nameOnCard
                            : `${selectedCard.nameOnCard}... ${selectedCard.cardNumber}`}
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {/* selection of card dropdown --end */}
                <div className="flex flex-1 flex-row lg:ml-5 relative mt-5 items-center ipad-portrait:mt-2">
                  {/* search input */}
                  <div className="flex items-center flex-1 relative">
                    <label htmlFor="search-transactions" className="sr-only">
                      {rb_transaction_history.searchPlaceholder}
                    </label>
                    <input
                      id="search-transactions"
                      type="text"
                      placeholder={rb_transaction_history.searchPlaceholder}
                      className="border border-[#cccccc] p-2 pl-12 flex-1 md:text-lg text-base"
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                    <img
                      src={assets.search_icon}
                      alt="SearchIcon"
                      className="absolute left-3 h-6 w-6"
                    />
                    {searchTerm && (
                      <img
                        src={assets.popup_close_icon}
                        alt="SearchIcon"
                        className="absolute right-3 h-6 w-6 cursor-pointer"
                        onClick={() => setSearchTerm('')}
                      />
                    )}
                  </div>
                  {/* search input  --end*/}
                  {/* filter popup + button */}
                  <Button
                    variant="outline"
                    aria-haspopup="dialog"
                    aria-expanded={isOpen}
                    aria-controls="filter-dialog"
                    className="bg-white md:min-w-32 h-11 flex items-center justify-between px-4 py-2 ml-2 border-[#cccccc] border hover:bg-[#ccc] text-[#333] hover:text-[#333]"
                    onClick={() => {
                      getButtonPosition();
                      setIsOpen(!isOpen);
                      if (isOpen) {
                        setSelectedMonth('');
                        setSelectedCategory('');
                      }
                      trackClickEvent(
                        !isOpen
                          ? 'transactions history|filter'
                          : 'transactions history|clear all'
                      );
                    }}
                    ref={ButtonRef}
                  >
                    {!isOpen && (
                      <img
                        src={assets.filter_icon}
                        alt="Open filter options"
                        className="h-6 w-6 mr-4"
                      />
                    )}
                    <span className="hidden md:block text-[#1f1f1f]">
                      {!isOpen
                        ? rb_transaction_history.filterTitle
                        : `${(selectedMonth ? 1 : 0) + (selectedCategory ? 1 : 0)} item${(selectedMonth ? 1 : 0) + (selectedCategory ? 1 : 0) > 1 ? 's' : ''}`}
                    </span>
                    {isOpen && (
                      <img
                        src={assets.popup_close_icon}
                        alt="Close filter options"
                        className="h-6 w-6 ml-4"
                      />
                    )}
                  </Button>

                  {isOpen && (
                    <div
                      id="filter-dialog"
                      ref={filterButtonRef}
                      className="absolute p-[20px] right-[0px] min-w-[300px] flex flex-1 bg-white border border-gray-300 rounded-lg shadow-lg z-10 before:content-[''] before:absolute before:top-[-8px] before:right-[40px] before:w-4 before:h-4 before:bg-white before:border-t before:border-l before:border-gray-300 before:rotate-45"
                      role="dialog"
                      aria-modal="true"
                      aria-labelledby="filter-dialog-title"
                      style={{
                        top: '107%',
                      }}
                    >
                      <div className="w-full" role="document">
                        <h2 id="filter-dialog-title" className="sr-only">
                          Transaction filter
                        </h2>

                        <div className="mb-4">
                          <label
                            className="block text-[#1F1F1F] mb-[8px]"
                            htmlFor="month-select"
                            aria-label={
                              rb_transaction_history?.transactionsFilter
                                ?.selectmonth
                            }
                          >
                            {
                              rb_transaction_history?.transactionsFilter
                                ?.selectmonth
                            }
                          </label>
                          <div className="w-full pl-3 pr-3 pt-2 pb-2 border border-gray-300">
                            <select
                              value={selectedMonth}
                              onChange={(e) =>
                                handleMonthChange(e.target.value)
                              }
                              className="w-full border-gray-300 focus:border-gray-500 focus:outline-none"
                              id="month-select"
                            >
                              <option
                                value=""
                                className="text-[#666666]"
                                aria-label={
                                  rb_transaction_history?.transactionsSelectOption
                                }
                              >
                                {
                                  rb_transaction_history?.transactionsSelectOption
                                }
                              </option>
                              <option key="current_month" value="current_month">
                                Current transactions
                              </option>
                              {transactionCycleDates?.map((date) => (
                                <option key={date} value={date}>
                                  {moment(date).locale(lang).format('MMM YYYY')}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="category-select"
                            className="block text-[#1F1F1F] mb-[8px]"
                            aria-label={
                              rb_transaction_history?.transactionsFilter
                                ?.selectcategory
                            }
                          >
                            {
                              rb_transaction_history?.transactionsFilter
                                ?.selectcategory
                            }
                          </label>
                          <div className="pl-3 pr-3 pt-2 pb-2 border border-gray-300">
                            <select
                              id="category-select"
                              value={selectedCategory}
                              onChange={(e) =>
                                handleCategoryChange(e.target.value)
                              }
                              className="w-full border-gray-300 focus:border-gray-500 focus:outline-none"
                            >
                              <option value="">
                                {
                                  rb_recent_transactions?.filterCategoryList[
                                    'all_categories'
                                  ]
                                }
                              </option>

                              {Object.entries(
                                rb_recent_transactions?.filterCategoryList || {}
                              )
                                .filter(([key]) => key !== 'all_categories')
                                .map(([key, value]) => {
                                  if (
                                    typeof value === 'string' ||
                                    typeof value === 'number'
                                  ) {
                                    return (
                                      <option key={key} value={key}>
                                        {value}
                                      </option>
                                    );
                                  }
                                  return null;
                                })}
                            </select>
                          </div>
                        </div>

                        <div className="flex justify-between mt-[15px]">
                          <Button
                            ariaLabel={
                              rb_transaction_history?.transactionsFilter
                                ?.clearall
                            }
                            variant="outline"
                            className="w-[50%] bg-white pl-4 pr-4 pt-2 pb-2 mr-5 text-ellipsis whitespace-nowrap text-[#DA291C]"
                            onClick={() => {
                              clearFilter();
                              setIsOpen(false);
                              setSelectedMonth('');
                              setSelectedCategory('');
                              trackClickEvent('transactions history|clear all');
                            }}
                          >
                            {
                              rb_transaction_history?.transactionsFilter
                                ?.clearall
                            }
                          </Button>
                          <Button
                            ariaLabel={
                              rb_transaction_history?.transactionsFilter?.apply
                            }
                            className={`w-[50%] pl-4 pr-4 pt-2 pb-2 ${
                              shouldEnableApplyButton()
                                ? 'bg-[#DA291C] text-white hover:bg-red-700'
                                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            }`}
                            onClick={() =>
                              shouldEnableApplyButton() &&
                              applyMonthCategoryChanges()
                            }
                            disabled={!shouldEnableApplyButton()}
                          >
                            {rb_transaction_history?.transactionsFilter?.apply}
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* filter popup + button */}

              <TransactionTable
                totalAmount={totalAmount}
                rb_recent_transactions={rb_recent_transactions}
                rb_transaction_history={rb_transaction_history}
                filteredActivities={filteredActivities}
                transactions={transactions}
                openModal={openModal}
                isFirstLoad={isFirstLoad}
                eppDetails={eppDetails}
                CardHolders={CardHolders}
                assets={assets}
                groupedActivities={groupedActivities}
                productName={productName}
                selectedCard={selectedCard}
                currentUser={current_login_username}
                offset={offset}
                setOffset={setOffset}
                totalCount={totalCount}
                rb_epp={rb_epp}
              />
            </div>
          </div>

          <div>
            <Modal
              isOpen={modalIsOpen}
              // onRequestClose={closeModal}
              contentLabel="Filter PopUp"
              className="fixed right-0 top-0 bottom-0 p-0 m-2 xl:w-[31%] lg:w-[75%] md:w-[75%] sm:w-[100%] outline-none"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50"
            >
              {selectedTransaction && (
                <TransactionDetails
                  setModalIsOpen={setModalIsOpen}
                  onClose={closeModal}
                  transactionDetails={selectedTransaction}
                  setShowFeatureFlagMessage={setShowFeatureFlagMessage}
                  featureFlaggingData={
                    entries?.rb_feature_flagging?.featureFlagging?.transactions
                      ?.transaction_details?.contact_us
                  }
                  rb_epp={rb_epp}
                  accountId={accountId}
                  customerId={customerId}
                />
              )}
            </Modal>
          </div>
        </div>
      )}
    </>
  );
};

export default Transactions;
